// extracted by mini-css-extract-plugin
export default {"trucksPostHeaderActions":"style_trucksPostHeaderActions__Cp76t","headerSubTab":"style_headerSubTab__Hwr8D","headerTipButton":"style_headerTipButton__Yp-Oc"};